import { getNotificationNavigationPath } from './notificationNavigation';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { App } from '@capacitor/app';
import { initNativePushNotifications } from '../services/pushNotificationService';

export async function initCapacitor() {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  try {
    // 1. Status Bar Setup
    await StatusBar.setStyle({ style: Style.Dark });
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#09090b' });
    }
  } catch (err) {
    console.warn('Capacitor StatusBar init notice:', err);
  }

  try {
    // 2. Android Hardware Back Button Handling
    App.addListener('backButton', ({ canGoBack }) => {
      const path = window.location.pathname;
      const isRootPage = path === '/' || path === '/dashboard' || path === '/login';

      if (canGoBack && !isRootPage) {
        window.history.back();
      } else {
        App.minimizeApp();
      }
    });
  } catch (err) {
    console.warn('Capacitor BackButton init notice:', err);
  }

  try {
    // 3. Splash Screen auto-hide after React renders
    setTimeout(async () => {
      await SplashScreen.hide();
    }, 200);
  } catch (err) {
    console.warn('Capacitor SplashScreen hide notice:', err);
  }

  try {
    // 4. Native Push & Local Notification Listener Setup
    await initNativePushNotifications((data) => {
      const user = JSON.parse(localStorage.getItem('goodvale_user') || 'null');
      window.location.assign(user ? getNotificationNavigationPath(data, user, user.role === 'SystemAdmin') : '/login');
    });
  } catch (err) {
    console.warn('Capacitor Push init notice:', err);
  }
}
